import { CustomizedButton } from 'components/common';
import { AddAssociatedDocuments } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/addAssociatedDocuments';
import { LinksView } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/LinksView/LinksView';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/mobile/AssociatedDocuments.mobile.module.scss';
import { UseFormWatch } from 'react-hook-form';
import { Dispatch, SetStateAction } from 'react';

interface Props {
    watch: UseFormWatch<any>;
    setShowAddAssociatedDocuments: Dispatch<SetStateAction<boolean>>;
    handleAddAssociatedDocumentsLinks: (data) => void;
    handleAddAssociatedDocumentsFiles: (data) => void;
    showAddAssociatedDocuments: boolean;
    handleDeleteAssociatedDocumentsLinks: (index: number) => void;
    handleDeleteAssociatedDocuments: (id: number) => void;
}

export const AssociatedDocumentsMobile = ({
    watch,
    setShowAddAssociatedDocuments,
    handleAddAssociatedDocumentsFiles,
    showAddAssociatedDocuments,
    handleAddAssociatedDocumentsLinks,
    handleDeleteAssociatedDocumentsLinks,
    handleDeleteAssociatedDocuments,
}: Props) => {
    const numberOfExternalDocuments =
        (watch('externalDocuments') && watch('externalDocuments').filter((doc) => doc.delete === undefined).length) ||
        0;
    const numberOfExternalLinks = (watch('externalLinks') && watch('externalLinks').length) || 0;
    const numberOfAttachments: number = numberOfExternalDocuments + numberOfExternalLinks;

    return (
        <div className={classes.associatedDocumentsContainer}>
            <CustomizedButton color="secondary" onClick={() => setShowAddAssociatedDocuments(true)}>
                {`Associated Documents (${numberOfAttachments}):`}
            </CustomizedButton>

            <AddAssociatedDocuments
                hasExternalDocumentsProperty={watch('externalDocuments') !== undefined}
                handleClose={() => setShowAddAssociatedDocuments(false)}
                handleAddDocumentsLink={handleAddAssociatedDocumentsLinks}
                showAddAssociatedDocuments={showAddAssociatedDocuments}
                handleAddAssociatedDocumentsFiles={handleAddAssociatedDocumentsFiles}
            />
            <LinksView
                watch={watch}
                handleDeleteAssociatedDocumentsLinks={handleDeleteAssociatedDocumentsLinks}
                handleDeleteAssociatedDocuments={handleDeleteAssociatedDocuments}
            />
        </div>
    );
};
